<template>
  <div class="horizontal-line-wrapper">
    <hr :class="customClass" :style="customStyle" :width="width">
  </div>
</template>
<script>
  export default {
    name: 'HorizontalLine',
    props: {
      width: {
        required: false,
        type: String,
        default: '100%',
      },
      customClass: {
        required: false,
        type: String,
        default: '',
      },
      customStyle: {
        required: false,
        type: String,
        default: '',
      },
    },
  };
</script>
